module.exports = __webpack_public_path__ + "img/lost.1ea4ba92.png";